import React, { useState } from 'react';
import SortButton from '../../UI/SortButton';
import classes from '../index.module.scss';

const UsersTableHeader = () => {
  const [sortedBy, setSortedBy] = useState({
    username: null,
    email: null,
    role_description: null,
    is_active: null,
    registration_date: null
  });

  return (
    <tr>
      <SortButton 
        name="Username"
        sortBy="username"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <SortButton 
        name="Contract Opportunity Name"
        sortBy="email"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <SortButton 
        name="Registration Date"
        sortBy="registration_date"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <SortButton 
        name="Type"
        sortBy="role_description"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <SortButton 
        name="Status"
        sortBy="is_active"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <th>
        Options
      </th>
    </tr>
  )
}

export default UsersTableHeader;